export const css = {
	root: '_3GTgerLX',
	question: '_1stj0ZLg',
	feedback: '_37sBDZ64',
	rationale: '_3On7hue6',
	fmi: '_1KtwsQYW',
	distractorBlock: 'n8QDywm_',
	distractorFieldset: 'mpbJ3ISj',
	distractorLegend: '_1lHDxsRd',
	distractor: '_7mQehXGs',
	distractorLabel: '_3H8xa296',
	distractorWithFlag: 'XLDmFqDI',
	distractorHint: '_2Yd1WKFb',
	actions: '_1mDtogDh',
	oneaction: '_1GJtVJHW',
	markblock: '_2IxF0ecs',
	timerblock: '_1vvKygcD',
	timer: 'yd-lnXrQ',
	' _key': 'afcpe-theme/afcpe/quiz-widgets/mcquestion'
};

export default css;
